import { useCallback, useEffect, useState } from "react";
import { axiosInstant } from "../../api";

export type ChatType = "recruiter-candidate" | "recruiter-manager";

// Unread chat messages per job application, for one kind of conversation. A
// recruiter has two chats per application (candidate, hiring manager) and each
// badge has to count only its own. Polled, so a message that arrives while the
// list is open shows up without a reload; opening a chat clears it at once via
// the 'chatRead' event RemarksPanel dispatches.
export const useChatUnreadCounts = (chatType: ChatType, pollMs = 10000) => {
  const [counts, setCounts] = useState<{ [jobApplicationId: string]: number }>({});

  const refresh = useCallback(() => {
    axiosInstant
      .get("/notifications/my/chat-unread-counts", { params: { chatType } })
      .then((res) => setCounts(res.data || {}))
      .catch(() => undefined);
  }, [chatType]);

  useEffect(() => {
    refresh();
    const timer = setInterval(refresh, pollMs);
    return () => clearInterval(timer);
  }, [refresh, pollMs]);

  useEffect(() => {
    const onRead = (event: any) => {
      const { jobApplicationId, chatType: readType } = event?.detail || {};
      if (!jobApplicationId || (readType && readType !== chatType)) return;
      setCounts((prev) => ({ ...prev, [jobApplicationId]: 0 }));
    };
    window.addEventListener("chatRead", onRead);
    return () => window.removeEventListener("chatRead", onRead);
  }, [chatType]);

  return counts;
};
